import React, { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Layout from '#AdminPanelFrontend/authorized/components/Layout';
import { useMenu } from '#AdminPanelFrontend/contexts/MenuContext';

const MenuHandler: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const location = useLocation();
	const { setMenuVisible } = useMenu();

	useEffect(() => {
		setMenuVisible(true);
	}, [location, setMenuVisible]);

	return <>{children}</>;
};

const App: React.FC = () => {
	const { menuItems } = useMenu();

	return (
		<Router>
			<MenuHandler>
				<Suspense fallback={<div>Loading...</div>}>
					<Routes>
						<Route key="layout" path="/" element={<Layout />}>
							{menuItems.flatMap((item) => {
								const Component = lazy(
									() => import(`#AdminPanelFrontend/authorized/pages/${item.componentPath}`)
								);
								const routes = [<Route key={item.path} path={item.path} element={<Component />} />];
								if (item.subItems) {
									routes.push(
										...item.subItems.flatMap((subItem) => {
											const SubComponent = lazy(
												() =>
													import(
														`#AdminPanelFrontend/authorized/pages/${subItem.componentPath}`
													)
											);
											const subItemPaths = [
												subItem.path,
												subItem.params !== undefined && subItem.params.length > 0
													? `${subItem.path}/:${subItem.params.join('/:')}`
													: null,
											].filter((item) => item !== null) as string[];
											return subItemPaths.map((subItemPath) => (
												<Route
													key={subItemPath}
													path={subItemPath}
													element={<SubComponent />}
												/>
											));
										})
									);
								}
								return routes;
							})}
						</Route>
					</Routes>
				</Suspense>
			</MenuHandler>
		</Router>
	);
};

export default App;
